import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getEmergencyContactById, getRelationshipList, saveEmergencyContact } from '../../actions/emergencyContact'
import { withNamespaces } from 'react-i18next';
import * as StatusCode from '../../scripts/StatusCode';
import * as StatusEmergencyCode from '../../scripts/StatusEmergencyContact';
import { IsEnglish } from '../../utils/language'
import LoadingLayer from '../controls/LoadingLayer';
import AlertAlgo from '../controls/AlertSnack'
import i18next from 'i18next';
import { toPhone, isEmpty, cleanData, isValidPhone, isValidEmail } from '../../utils';
import Button from 'react-bootstrap-button-loader';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import PhoneTextField from '../controls/PhoneTextField';
import IntTextField from '../controls/IntTextField';
import styles from '../../styles/emergencyContact.module.css';

const useStyles = makeStyles((theme) => ({
    divButtons: {
        marginTop: '10px',
        textAlign: 'center'
    }
}));

function EmergencyContactForm(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [relationships, setRelationships] = useState([]);
    const [emergencyContactId, setEmergencyContactId] = useState(props.id);
    const [priority, setPriority] = useState(0);
    const [name, setName] = useState('');
    const [relationship, setRelationship] = useState('');
    const [phoneOffice, setPhoneOffice] = useState('');
    const [extension, setExtension] = useState('');
    const [phone, setPhone] = useState('');
    const [cellphone, setCellphone] = useState('');
    const [email, setEmail] = useState('');
    const [comment, setComment] = useState('');
    const [isProcessing, setIsProcessing] = useState(true);
    const alertRef = useRef(null);

    useEffect(() => {
        loadList();
    }, []);

    useEffect(() => {
        if (data.id > 0) {
            setPriority(data.priority);
            setName(data.contactName);
            setRelationship(data.relationshipCode);
            setPhoneOffice(data.phoneOffice);
            setExtension(data.extensionOffice);
            setPhone(data.phone);
            setCellphone(data.cellphone);
            setEmail(data.email);
            setComment(data.other);
        }
    }, [data]);

    const loadList = async () => {
        if (emergencyContactId <= 0) {
            loadRelationship();
        } else {
            const response = await getEmergencyContactById(emergencyContactId);

            if (response != null && response.status == StatusCode.STATUS_OK) {
                setData(response.result);

                loadRelationship();
            } else {
                showMessageError(i18next.t('error:generic-error'));
                setIsProcessing(false);
            }
        }
    }

    const loadRelationship = async () => {
        const response = await getRelationshipList();

        if (response != null && response.status == StatusCode.STATUS_OK) {
            setRelationships(response.result);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
        setIsProcessing(false);
    }

    const onChangePriority = (event) => {
        setPriority(parseInt(event.target.value));
    }

    const onChangeName = (event) => {
        setName(event.target.value);
    }

    const onChangeRelationship = (event) => {
        setRelationship(event.target.value);
    }

    const onChangePhoneOffice = (event) => {
        setPhoneOffice(toPhone(event.target.value));
    }

    const onChangeExtension = (event) => {
        setExtension(event.target.value);
    }

    const onChangePhone = (event) => {
        setPhone(toPhone(event.target.value));
    }

    const onChangeCellphone = (event) => {
        setCellphone(toPhone(event.target.value));
    }

    const onChangeEmail = (event) => {
        setEmail(event.target.value);
    }

    const onChangeComment = (event) => {
        setComment(event.target.value);
    }

    const handleClose = () => {
        props.handleClose();
    }

    const handleSave = async () => {
        if (isValidData()) {
            const response = await saveEmergencyContact(emergencyContactId, priority, name, cleanData(phone), cleanData(phoneOffice),
                extension, cleanData(cellphone), email, comment, relationship);

            if (response == null || (response != null && response.status == StatusCode.STATUS_OK && response.result == StatusEmergencyCode.STATUS_PRIORITYEXISTS)) {
                // Priority already exists
                showMessageError(i18next.t('emergencyContact:message.priority-exists'));
                return;
            } else if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
                // Error
                showMessageError(i18next.t('error:generic-error'));
                return;
            };

            handleClose();
        }
    }

    const isValidData = () => {
        let message = '';

        if (priority <= 0) {
            message = i18next.t('emergencyContact:message.priority-form');
        } else if (isEmpty(name)) {
            message = i18next.t('emergencyContact:message.name-form');
        } else if (isEmpty(relationship)) {
            message = i18next.t('emergencyContact:message.relationship-form');
        } else if (!isEmpty(phoneOffice) && !isValidPhone(phoneOffice)) {
            message = i18next.t('emergencyContact:message.phoneOffice-valid-form');
        } else if (!isEmpty(phone) && !isValidPhone(phone)) {
            message = i18next.t('emergencyContact:message.phone-valid-form');
        } else if (!isEmpty(cellphone) && !isValidPhone(cellphone)) {
            message = i18next.t('emergencyContact:message.cellphone-valid-form');
        } else if (!isEmpty(email) && !isValidEmail(email)) {
            message = i18next.t('emergencyContact:message.email-valid-form');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handleFocus = (event) => {
        // this should be good on desktop and android
        //event.target.select();

        // workaround to make it work in iOS
        event.target.setSelectionRange(0, event.target.value.length);
    }

    return (
        <div className={styles.rootPopBody + " " + styles.rootEmergency}>
            <LoadingLayer isActive={isProcessing}>
                <FormControl fullWidth>
                    <IntTextField
                        id="priority"
                        label={i18next.t('emergencyContact:list.priority')}
                        value={priority || 0}
                        handleChange={onChangePriority}
                        onFocus={handleFocus}
                        className={'required'}
                        min={0}
                        max={99}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="name"
                        label={i18next.t('emergencyContact:list.name')}
                        value={name || ''}
                        onChange={onChangeName}
                        className={'required'}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <div>
                        <InputLabel className={'required'}>{i18next.t('emergencyContact:list.relationship')}</InputLabel>
                        <Select
                            id="relationship"
                            value={relationship || ''}
                            onChange={onChangeRelationship}
                        >
                            {relationships && relationships.map((obj, index) =>
                                <MenuItem key={index} className={styles.selectItem} value={obj.value}>{IsEnglish() ? obj.textE : obj.textF}</MenuItem>
                            )}
                        </Select>
                    </div>
                </FormControl>

                <FormControl fullWidth>
                    <PhoneTextField
                        name="phoneOffice"
                        id="phoneOffice"
                        label={i18next.t('emergencyContact:list.phoneOffice')}
                        value={phoneOffice || ''}
                        placeholder="xxx xxx-xxxx"
                        handleChange={onChangePhoneOffice}
                    />

                    <TextField
                        id="extension"
                        label={i18next.t('emergencyContact:list.extension')}
                        value={extension || ''}
                        onChange={onChangeExtension}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <PhoneTextField
                        name="phone"
                        id="phone"
                        label={i18next.t('emergencyContact:list.phone')}
                        value={phone || ''}
                        placeholder="xxx xxx-xxxx"
                        handleChange={onChangePhone}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <PhoneTextField
                        name="cellphone"
                        id="cellphone"
                        label={i18next.t('emergencyContact:list.cellphone')}
                        value={cellphone || ''}
                        placeholder="xxx xxx-xxxx"
                        handleChange={onChangeCellphone}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="email"
                        label={i18next.t('emergencyContact:list.email')}
                        value={email || ''}
                        onChange={onChangeEmail}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="comment"
                        label={i18next.t('emergencyContact:list.comment')}
                        multiline
                        minRows={4}
                        onChange={onChangeComment}
                        value={comment || ''}
                    />
                </FormControl>

                <div className="formDivButtons">
                    <Button className="saveButton" onClick={handleSave} variant="success">
                        {i18next.t('buttons:save')}
                    </Button>
                </div>
                <AlertAlgo ref={alertRef} />
            </LoadingLayer>
        </div>
    )
}

export default withNamespaces(['emergencyContact', 'error'], { wait: true })(EmergencyContactForm);